export enum StoreKeyEnum {
  PICO_COM = "pico-com-store",
  CHLAST = "chlast-pico-store",
  KUKANA = "kukana-pico-store",
  SIPKY = "sipky-pico-store",
  BEERRALLY = "beerrally-pico-store",
}
